import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_2 = ["srcdoc"]

import { onMounted, ref, watch } from "vue";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";

import { translation } from "../../lang/Translation";
import { DialogHandler } from "./DialogHandler";
import { SessionMemory } from "../../utils/SessionMemory";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThumbnailEditorDialog',
  setup(__props) {

const t = translation;
const dialogId = DialogHandler.thumbnailEditorDialogId;

const title = t.to("プレビュー", "file_preview_title");
const takeThumbnailTitle = t.to("写真をサムネイルに設定", "take_thumbnail");

const assetPath = ref("");
const src = ref("");
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, () => {
    assetPath.value = SessionMemory.instance.thumbnailEditTarget;
    src.value = `
    <html>
    <${"script"}  type='module' defer src='${"https://cdn.jsdelivr.net/npm/@google/model-viewer@1.7.2/dist/model-viewer-umd.min.js"}'></${"script"}>
    <style>html,body,model-viewer{
      height: 100%;
    }</style>
    <body>
      <model-viewer id="mv"
        src='${assetPath.value}'
        shadow-intensity='1' camera-controls >
      </model-viewer>
    </body></html>
    `;
  });
});

const takePhoto = async () => {
  const frame = document.getElementById("thumbnail") as HTMLIFrameElement;
  const mv = frame.contentWindow.document.querySelector("#mv") as any;
  if (!mv) {
    MessageDialog.alertModal(
      t.to("サムネイルの取得に失敗しました", "error_take_thumbnail")
    );
    return;
  }
  const blob = await mv.toBlob();
  const data = mv.toDataURL();
  // console.log("snapshot", mv, blob, data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-md': true },
    title: _unref(title)
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("iframe", {
          id: "thumbnail",
          srcdoc: src.value,
          width: "300px",
          style: {"height":"50vh"}
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})